import { Pipe, PipeTransform } from '@angular/core';

/** Sums the digits of a numeric string ("12" → 3). Used by the credits
 *  consumption alert copy. Moved here from notification.component.ts so
 *  the shared message template can use it without importing the page. */
@Pipe({
  name: 'Adding',
  standalone: true
})
export class AddPipe implements PipeTransform {
  transform(value: string): number {
    let sum = 0;
    for (let index = 0; index < value.length; index++) {
      sum = sum + +value.charAt(index);
    }
    return sum;
  }
}

/** Renders post HTML as plain text for the "liked/commented on your post" copy. */
@Pipe({
  name: 'stripHtmlTags',
  standalone: true
})
export class StripHtmlTagsPipe implements PipeTransform {
  transform(value: string): string {
    const doc = new DOMParser().parseFromString(value, 'text/html');
    return doc.body.textContent || '';
  }
}
